import { forwardRef } from "react";

export const Flex = forwardRef(
  (
    {
      direction = "row",
      wrap = "nowrap",
      align = "stretch",
      justify = "flex-start",
      gap,
      children,
      className,
      style,
      ...rest
    },
    ref,
  ) => {
    const styles = {
      display: "flex",
      flexDirection: direction,
      flexWrap: wrap,
      alignItems: align,
      justifyContent: justify,
      ...(gap ? { gap } : {}),
      ...style,
    };

    return (
      <div ref={ref} className={className} style={styles} {...rest}>
        {children}
      </div>
    );
  },
);
